<template>
  <div class="home">
    <img src="../assets/title.png" style="max-width:40%;" />
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <div v-for="(data_unit,index) in data_all" :key="index">
      <h2 class="info">{{index}}</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index2"
        v-for="(data_pool,index2) in data_unit"
      >
        <el-col :span="10" v-for="(unit,index3) in data_pool" :key="index3">
          <!-- <div>{{index}}</div> -->
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
            :type="index"
          />
        </el-col> 
      </el-row>
      <br>
    </div>
    <!--<li>
      <h2 class="info">APPs</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_apps"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
    </li>
      <br>
      <li>
        <h2 class="info">WEBSITEs</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_websites"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
      </li>
      <br>
      <li>
        <h2 class="info">H5s</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_h5s"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
      </li>
      <br>
     <li>
       <h2 class="info">PLUGINs</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_plugins"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
     </li>
      <br>
      <li>
        <h2 class="info">TECHs</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_techs"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
      </li>
      <br>
      <li>
        <h2 class="info">WATCH FACEs</h2>
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        :key="index"
        v-for="(unitPool,index) in pool_watchfaces"
      >
        <el-col :span="10" v-for="(unit,index2) in unitPool" :key="index2">
          <CardLoopImage
            :name="unit.name"
            :platfom="unit.platfom"
            :folder="unit.folder"
            :img="unit.imgs[0]"
          />
        </el-col>
      </el-row>
      </li>
    -->
    <a class="info" @click="$router.push('/about')" target="_self"
      >About Zstudio</a
    >
    <br />
    <br />
    <br />
  </div>
</template>

<script>
// import Core from '@/core/core.js'
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import CardLoopImage from "@/components/card_loop_image.vue";
import DataJson from "@/core/data.json";
// import

export default {
  name: "home",
  data() {
    return {
      row: 3,
      // pool_apps: [],
      // pool_games: [],
      // pool_websites: [],
      // pool_h5s: [],
      // pool_plugins: [],
      // pool_techs: [],
      // pool_watchfaces: []
      data_all:{},
      // isChanged:false,
    };
  },
  components: {
    CardLoopImage
  },
  mounted: function() {
    // console.log(process.env.BASE_URL);
    // this.data = DataJson["data"];
    for(var k in DataJson["data"]){
      this.data_all[k] = [];
      var pool = DataJson["data"][k];
      var unitGroup = null;
      for(var i=0;i<pool.length;i++){
        if (i % this.row == 0) {
          unitGroup = [];
          this.data_all[k].push(unitGroup);
        }
        unitGroup.push(pool[i]);
      }
    }
    // this.isChanged=true;
    this.$set(this.data_all,this.data_all,2);
    for (const key in this.data_all) {
      if (key=="[object Object]") {
        delete this.data_all[key];
      }
      // console.log();
      // delete this.data_all[key];
    }
    // console.log(this.data);
    
    // var data = DataJson["data"]["apps"];
    // var pool = null;
    // var i;
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_apps.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["games"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_games.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["websites"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_websites.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["h5s"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_h5s.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["plugins"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_plugins.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["techs"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_techs.push(pool);
    //   }
    //   pool.push(data[i]);
    // }

    // data = DataJson["data"]["watchfaces"];
    // for (i = 0; i < data.length; i++) {
    //   if (i % this.row == 0) {
    //     pool = [];
    //     this.pool_watchfaces.push(pool);
    //   }
    //   pool.push(data[i]);
    // }
  }
};
</script>

<style lang="less">
.info {
  color: #ffffff;
}
</style>
